import React from "react";
import Nav from "../components/sections/Nav";
import Footer from "../components/sections/Footer";
import RevealOnScroll from "../components/RevealOnScroll";
import BotanicalOverlay from "../components/BotanicalOverlay";
import Seo from "../components/Seo";

const BERRY = "#7D3F5C";

export default function InnerCompassPage() {
    return (
        <main className="bg-ivory text-charcoal" data-testid="inner-compass-page">
            <Seo
                title="The Inner Compass | Astrology & Tarot | Alchemy Practice"
                description="Astrology and tarot for meaning-making and self-knowing. A different kind of guidance. Coming late summer from Alchemy Practice."
            />
            <Nav />
            <RevealOnScroll>
                <section
                    data-testid="inner-compass-hero"
                    className="relative overflow-hidden"
                    style={{ background: "#F5EDF1", paddingTop: "160px", paddingBottom: "160px" }}
                >
                    <BotanicalOverlay variant="right" opacity={0.1} />
                    <div
                        className="relative mx-auto px-6 text-center"
                        style={{ maxWidth: "600px", zIndex: 1 }}
                        data-reveal
                    >
                        <span
                            className="text-[11px] tracking-[0.32em] uppercase font-medium"
                            style={{ color: BERRY }}
                        >
                            Something is coming
                        </span>
                        <h1
                            className="mt-8 font-serif italic text-charcoal leading-[1.05]"
                            style={{ fontSize: "52px" }}
                        >
                            The Inner Compass
                        </h1>
                        <p
                            className="mt-8 mx-auto"
                            style={{
                                fontFamily: "Figtree, sans-serif",
                                fontSize: "15px",
                                color: "#8A7968",
                                lineHeight: 1.85,
                                maxWidth: "480px",
                            }}
                        >
                            Astrology. Tarot. A different kind of knowing. This space is being
                            prepared with care and will open in late summer. If you feel called to
                            this work before then, reach out.
                        </p>

                        <div
                            className="flex items-center justify-center gap-4 mt-10"
                            aria-hidden
                        >
                            <span style={{ height: 1, width: 48, background: BERRY, opacity: 0.55 }} />
                            <span style={{ color: BERRY }}>✦</span>
                            <span style={{ height: 1, width: 48, background: BERRY, opacity: 0.55 }} />
                        </div>

                        <div className="mt-10">
                            <a
                                href="/#contact"
                                data-testid="inner-compass-cta"
                                className="inline-flex items-center justify-center px-8 py-4 text-[12px] tracking-[0.28em] uppercase font-medium transition-all duration-500"
                                style={{
                                    border: `1px solid ${BERRY}`,
                                    color: BERRY,
                                    background: "transparent",
                                    borderRadius: 0,
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.background = BERRY;
                                    e.currentTarget.style.color = "#FAFAF8";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.background = "transparent";
                                    e.currentTarget.style.color = BERRY;
                                }}
                            >
                                Send a Note
                            </a>
                        </div>
                    </div>
                </section>
                <Footer />
            </RevealOnScroll>
        </main>
    );
}
